import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication-service';
import { Observable, map, of } from 'rxjs';
import { LoginData } from '../model/login-data';
import { UserInfo } from '../model/user-info';
import { LoginRequest } from '../model/api/login-request';
import { LoginResponse } from '../model/api/login-response';
import { UserService } from './user-service';
import { BasicHttpClientService } from '../../api/services/basic-http-client.service';
import { ComposeUrlService } from '../../api/services/compose-url.service';
import { ErrorData } from '../../api/model/error-data';
import { AuthenticationConfig } from '../model/authentication-config';


@Injectable()
export class AuthenticationBcApiService extends AuthenticationService {
  
  constructor(
    private httpClient: BasicHttpClientService,
    private userService: UserService,
    private composeUrlService: ComposeUrlService
  ) {
    super();
  }

  public authenticationConfig: AuthenticationConfig | undefined = undefined;
  
  public override logout(): Observable<void> {
    this.userService.clearUserInfo();
    // TODO pendiente de si hay llamada de logout
    return of(undefined);
  }

  public override login(data: LoginData): Observable<UserInfo> {
    const query: LoginRequest = {
      cContrasena: data.password,
      cUsuarioPDA: data.userId
    };
    this.userService.clearUserInfo();
    return this.httpClient
      .post<LoginRequest, LoginResponse>(this.composeUrlService.composeUrl(`CosmosApi_Login`), query)
      .pipe(
        map(data => {
          if (data !== undefined && data.Datos !== undefined && data.Datos.length > 0) {
            const result: UserInfo = {
              userId: data.Datos[0].Login,
              returnsNR: data.Datos[0]["Returns NR"]
            };
            this.userService.setUserInfo(result);
            return result;
          } else {
            throw new ErrorData("Data login failed");
          }
        })
      )
  }

  public override isAuthenticated(): Observable<boolean> {
    return of(this.userService.getUserName() !== null);
  }
}
